import { Flex } from '@mantine/core';
import styled from 'styled-components';

export const InnerContainer = styled.div<{ $disabled: boolean }>`
	width: 100%;
	display: flex;
	align-items: flex-start;
	gap: 0.5rem;
	cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
`;

export const CenterContainer = styled.div`
	width: 80%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
`;

export const RightContainer = styled.div<{ $opacity: number }>`
	width: 10%;
	display: flex;
	justify-content: flex-end;
	opacity: ${({ $opacity }) => $opacity ?? 1};
`;

export const LeftContainer = styled.div`
	width: 10%;
	display: flex;
	justify-content: center;
	align-self: flex-start;
`;

export const Container = styled.div`
	width: 100%;
	display: flex;
	padding: 0.5rem;
	flex-direction: column;
	gap: 0.5rem;
	align-items: flex-start;

	border-radius: 0.25rem;
	border: 1px solid ${({ theme }) => theme.color.greys[200]};
	background: ${({ theme }) => theme.color.white[500]};
`;

export const ExistingFileContainer = styled(Flex).attrs({
	direction: 'row',
	gap: '0.5rem',
	justify: 'center',
	mt: '1rem',
})`
	border-radius: 0.25rem;
	border: 1px solid ${({ theme }) => theme.color.greys[200]};
	background: ${({ theme }) => theme.color.white[500]};

	padding: 0.5rem;
`;
